import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) {}

  getHome(){
    return this.http.get(environment.apiUrl + 'count');
  }

  getSeo(){
    return this.http.get(environment.apiUrl + 'seo');
  }

  updateSeo(data: any){
    return this.http.post(environment.apiUrl +  'admin/save/seo', data);
  }
  


}
